import React from 'react'
import {useParams} from 'react-router-dom'
import useEffect from 'admin/hooks/useEffect'
import useService from 'admin/hooks/useService'
import useDocument from 'admin/hooks/useDocument'
import useStateObject from 'admin/hooks/useStateObject'
import InputField from 'admin/components/shared/InputField'
import PlanSelect from 'admin/components/shared/PlanSelect'
import Modal from 'admin/components/shared/Modal'
import EditField from 'admin/components/shared/EditField'
import Map from '../shared/Map'
import Switch from '../shared/Switch'
import Header from '../shared/Header'
import useModal from '../../hooks/useModal'
import ModalLink from '../shared/ModalLink'

export default () => {
  const {organisationID} = useParams()
  const {accountId, serviceId, popModal} = useModal()
  const {service, errors, update} = useService(organisationID, accountId, serviceId)
  const [form, setForm, resetForm] = useStateObject(service)

  const title = `Service ${serviceId}`
  useDocument({title})

  useEffect(() => setForm(service), [service], false)

  const handleUpdate = e => {
    e.preventDefault()
    update(form)
  }

  const handlePlanSelection = plan => setForm({plan, planId: plan?.id})
  const handleCoordsSelection = ({lat, lng}) => setForm({coords: [lat, lng]})

  const handleClose = e => {
    e.preventDefault()
    resetForm(service)
    popModal('service', ['serviceId', 'accountId'])
  }

  return (
    <Modal onClose={handleClose} flashId='edit-service'>
      <Header title={title}>
        <ModalLink
          modal='history'
          params={{itemType: 'AccountInternetService', itemId: serviceId}}
          className='button is-white'>
          <span className='icon is-small'>
            <i className='fa fa-history' aria-hidden='true'></i>
          </span>
          <span>View History</span>
        </ModalLink>
        <button className='button is-success' onClick={handleUpdate}>
          Save
        </button>
      </Header>
      <section className='section'>
        <div className='container'>
          <div className='field is-grouped'>
            <div className='control is-expanded'>
              <div className='field'>
                <label className='label is-small'>Billing account</label>
                <div className='control'>{form.account?.displayName}</div>
              </div>
            </div>
            <div className='control'>
              <div className='field'>
                <label className='label is-small'>Service plan</label>
                <div className='control'>
                  <PlanSelect
                    buttonText={form.plan && form.plan.name}
                    onChange={handlePlanSelection}
                    errors={errors.internetServicePlanId}
                  />
                </div>
              </div>
            </div>
            <div className='control'>
              <Switch
                name='status'
                value={{pending: null, active: true, inactive: false}[form.status]}
                text={{pending: 'Pending', active: 'Active', inactive: 'Inactive'}[form.status]}
                onChange={({status}) => setForm({status: status ? 'active' : 'inactive'})}
              />
            </div>
          </div>
          <InputField
            name='description'
            label='Description'
            placeholder='Sleepout at the back'
            value={form.description || ''}
            onChange={setForm}
            errors={errors.description}
          />
          <EditField
            onChange={setForm}
            values={{ipAddress: form.ipAddress || '', macAddress: form.macAddress || ''}}
            labels={{ipAddress: 'IP Address', macAddress: 'MAC Address'}}
            placeholders={{ipAddress: '10.10.10.56', macAddress: '78:7B:8A:B2:D8:CB'}}
            errors={{ipAddress: errors.ipAddress, macAddress: errors.macAddress}}
          />
          <div className='field is-grouped'>
            <div className='control is-expanded'>
              <InputField
                type='text'
                name='address'
                placeholder='15 Havill Drive, Awatuna 7882'
                value={form.address || ''}
                onChange={setForm}
                errors={errors.address}
              />
            </div>
            <div className='control is-expanded'>
              <InputField
                type='text'
                name='coords'
                label='Location'
                placeholder='-40.988, 173.771'
                value={form.coords?.join(', ') || ''}
                onChange={setForm}
                errors={errors.coords}
                disabled
              />
            </div>
          </div>
          <Map className='field' height='30vh' coords={form.coords} onClick={handleCoordsSelection} />
        </div>
      </section>
    </Modal>
  )
}
